import RESOURCES from '@/store/lib/constants';
import { RECORD_TYPE } from '@/app/data/model_constants';
import RECORD_ACTIONS from '@/store/lib/actions';
import api from '@/api';

const API_ENDPOINT = '/app/v1/shared/themes/';

const SCHEMA = {
  ...RESOURCES[RECORD_TYPE.THEME],
  included: [],
};

const state = {
  themes: [],
};

const actions = {
  FETCH_THEME: async ({ id }) => {
    const r = await api.get(`${API_ENDPOINT}${id}`);
    return r.data.data;
  },
  FETCH_THEMES: async (params = {}) => {
    const { tenantable_id = null, tenantable_type = 'Client' } = params;
    if (tenantable_id) {
      const r = await api.get(`${API_ENDPOINT}?tenantable_id=${tenantable_id}&tenantable_type=${tenantable_type}`);
      return r.data.data;
    }
    const r = await api.get(`${API_ENDPOINT}`);
    return r.data.data;
  },
  UPDATE_THEME: RECORD_ACTIONS.UPDATE_RECORD(API_ENDPOINT, SCHEMA),
  UPDATE_THEMES: RECORD_ACTIONS.UPDATE_RECORDS(API_ENDPOINT, SCHEMA),
};

export default {
  actions,
  state,
};
